/**
 * Version 0.0.0
 *
 *
 * Author: Oded Sagir
 * @param  Object require -for adding dependencies
 * @return Object         -Class Object
 */
define(function(require) {
    'use strict';

    var template = require('registration-templates/my-account/myAccountView.tmpl');
    var ApiResources = require("assets/data/apiResources.json");
    var LEResourceResolver = require("leResourceResolver");
    var DateUtility = require("utils/DateUtility");
    var GeneralUtils = require("reporting-assets/js/GeneralUtils");
    var errorCodes = require("registration-assets/data/errorCodes.json");
    var Loader = require("ui/loader/Loader");
    var LEConfig = require("assets/config/le-env-conf");
    var UrlUtilities = require("utils/UrlUtilities");

    // Components
    var Button = require("ui/button/Button");

    // Model
    var InvoicesModel = require("registration-models/InvoicesModel");

    // VIEWS
    var PlanView = require("registration-views/plan-selection/PlanView");



    var MyAccountView = {};
    LE.module('LERegistration', function (LERegistration, LE, Backbone, Marionette, $, _) {

        MyAccountView = Marionette.ItemView.extend({
            template: template,
            className: "my-account-body",

            events: {
                "click .js_invoiceNumber": "_downloadInvoice",
                "click .chatWithUs": "_openChat",
                "click .upgradeNow": "_openChat",
                "click .usageLeanMore": "_leanMoreKnowledgePack"
            },

            withUIComponents: true,
            ui: {
                cancelBtn: ".button-cancel",
                updatePaymentDetailsLink: ".update-payment-details",
                updateOwnerDetails: ".update-owner-details",
                changeMyPlanLink: ".change-my-plan",
                viewReportsLink: ".view-reports",
                viewAllInvoicesLink: ".view-all-invoices",
                recentInvoicesTable: ".recent-invoices"
            },

            uiComponents: {
                cancelBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelBtn",
                        permutation: Button.PERMUTATION.BUTTON,
                        initState: Button.STATES.ENABLED
                    },
                    events: {
                        "click": "_onClosePage"
                    }
                },

                updateOwnerDetails : {
                    type: Button,
                    options: {
                        el: "view.ui.updateOwnerDetails",
                        permutation: Button.PERMUTATION.BLUELINK

                    },
                    events: {
                        "click": "_goToBillingDashboard"
                    }
                },

                changeMyPlanLink: {
                    type: Button,
                    options: {
                        el: "view.ui.changeMyPlanLink",
                        permutation: Button.PERMUTATION.BLUELINK
                    },
                    events: {
                        "click": "_onChangeMyPlanClicked"
                    }
                },

                viewReportsLink: {
                    type: Button,
                    options: {
                        el: "view.ui.viewReportsLink",
                        permutation: Button.PERMUTATION.BLUELINK
                    },
                    events: {
                        "click": "_onViewReportsClicked"
                    }
                },

                updatePaymentDetailsLink: {
                    type: Button,
                    options: {
                        el: "view.ui.updatePaymentDetailsLink",
                        permutation: Button.PERMUTATION.BLUELINK
                    },
                    events: {
                        "click": "_goToBillingDashboard"
                    }
                },

                viewAllInvoicesLink: {
                    type: Button,
                    options: {
                        el: "view.ui.viewAllInvoicesLink",
                        permutation: Button.PERMUTATION.BLUELINK
                    },
                    events: {
                        "click": "_goToBillingDashboard"
                    }
                }
            },

            initialize: function(options){
                LERegistration.logger.info("view initialize", "MyAccountView:initialize");
                this.controller= options.controller;

                // render the panes with their loaders prior to fetching all the data
                // upon each pane's data arriving a rerender would be executed
                this.render();
                this.loadPanes();
            },

            parseTemplateHelpers: function(){
                var parsed= {};

                try{
                    //preserve errors upon recalls to this function when pane's data resolves
                    parsed.errorText= this.model.get('parsed.errorText');
                    if(LE.sessionManager.isSeatBasedFeature()){
                        parsed.seatBased= "seatBased";
                        parsed.numOfSeats= this.model.get('currentPlan.ratePlanCharges.USD.quantity');
                    }

                    if(this.model.get('currentPlan')){
                        if(this.model.get('engagementUsage') >= 0){
                            if(parsed.seatBased){
                                parsed.hasEngagementUsage= true;
                            }else{
                                // plan pane parsed model
                                parsed.engagementUsagePercent= Math.round( 100 * this.model.get('engagementUsage') / this.model.get('currentPlan.includedUnits') );
                                parsed.hasEngagementUsage= !isNaN(parsed.engagementUsagePercent);
                                if(parsed.hasEngagementUsage){
                                    parsed.overageExists= parsed.engagementUsagePercent > 100;
                                    parsed.nearQuota= 80 <= parsed.engagementUsagePercent && parsed.engagementUsagePercent <= 100;
                                    parsed.reachedQuota= parsed.engagementUsagePercent === 100;
                                    parsed.engagementUsagePercentBarWidth= parsed.engagementUsagePercent + "%";
                                    if(parsed.engagementUsagePercent === 0){
                                        parsed.engagementUsagePercentBarWidth= "20px";
                                    }
                                    parsed.engagementUsagePercent+= "%";
                                    parsed.usageNotificationText= LE.translator.translate("LERegistration.myAccount.usage.notification").replace("{0}", parsed.engagementUsagePercent);
                                } else {
                                    LERegistration.logger.error("MyAccountView failed to calculate engagementUsagePercent", "MyAccountView:parseTemplateHelpers", {usage: this.model.get('engagementUsage'), quota: this.model.get('currentPlan.includedUnits') });
                                }
                            }
                        }

                        parsePlan("currentPlan", this.model);
                        parsePlan("amendedPlan", this.model);
                    }

                    if(this.model.get('invoices') && parsed.invoices === undefined){
                        // create invoice rows
                        parsed.invoices= _.toArray(this.model.get("invoices"));
                    }

                    this.model.set('parsed', parsed);
                    LERegistration.logger.debug("This is the MyAccountView model after it has been parsed.", "MyAccountView:parseTemplateHelpers", parsed);

                    //throw new Error("shit happens!"); //Mock exception

                }catch(e){
                    this.controller.handleRegistrationError("JavaScript error in parsing the model for MyAccount view", errorCodes.jsMyAccountError, "myAccount", e);
                    LERegistration.logger.info(e.message, "MyAccountView:parseTemplateHelpers");
                    throw e;
                }

                function parsePlan(type, model) {
                    if(model.get(type)){
                        // plan cycle
                        var planCycle;
                        switch(model.get(type+".baseBillingFrequencyMonths")){
                            case 1:
                            planCycle= PlanView.BILLING_CYCLE.MONTH;
                            break;
                            case 3:
                            planCycle= PlanView.BILLING_CYCLE.QUARTER;
                            break;
                            case 6:
                            planCycle= PlanView.BILLING_CYCLE.SEMI_ANNUAL;
                            break;
                            case 12:
                            planCycle= PlanView.BILLING_CYCLE.ANNUAL;
                            break;
                            case 36:
                            planCycle= PlanView.BILLING_CYCLE.THREE_YEARS;
                            break;
                            default:
                                LERegistration.logger.error("plan cycle is " + model.get(type+".baseBillingFrequencyMonths"), "MyAccountView:parsePlan");
                                planCycle= PlanView.BILLING_CYCLE.NULL;
                        }

                        // monthly charge
                        var USD= model.get(type+".ratePlanCharges").USD;
                        var discountPrice = (USD.flatFeePrice - USD.discountPrice)/model.get(type+".baseBillingFrequencyMonths");
                        if(!discountPrice){
                            discountPrice= USD.flatFeePrice/model.get(type + ".baseBillingFrequencyMonths");
                        }

                        var discountPercentage = USD.discountPercentage;

                        // start date
                        var effectiveDate= model.get(type+".effectiveStartDate");
                        if(effectiveDate){
                            effectiveDate= DateUtility.strToDateObj(effectiveDate);
                            effectiveDate= DateUtility.getDateToShow(effectiveDate);
                        }

                        var starting= LE.translator.translate("LERegistration.myAccount.amendment.starting").replace("{0}", effectiveDate || "");

                        // end date
                        //TODO(Maor): wire the end date to this local var
                        //var discountEndDate=   USD.endDate ? DateUtility.getDateToShow(new Date(USD.endDate)) : "?";

                        // extend parsed object
                        parsed[type]= {};
                        parsed[type].cycleLabel= LE.translator.translate("LERegistration.myAccount.current.monthly.rate").replace("{0}", LE.translator.translate("LERegistration.plan.period." + planCycle.key).toLowerCase() );
                        if(discountPrice) {
                            parsed[type].monthlyCharge = "$" + discountPrice.toFixed(2);
                        }
                        parsed[type].startDate= starting;
                        parsed[type].overageUnitPrice= USD.overageUnitPrice && USD.overageUnitPrice.toFixed(2);
                        parsed[type].discountPercentage = discountPercentage ? discountPercentage + "%" : false ;
                        //parsed[type].discountPercentageLabel = LE.translator.translate("LERegistration.myAccount.current.discount").replace("{0}", discountEndDate );
                    }
                }

            },

            onRender: function(){
                // turn on loaders according to whats in this.panes array
                this.loaders= {};
                _(this.panes).forEach(_.bind(function(paneName){
                    this.loaders[paneName] = this.loaders[paneName] || new Loader({
                        permutation: Loader.PERMUTATION.J,
                        el: this.$el.find('.' + paneName + '-loader'),
                        text: LE.translator.translate("LERegistration.myAccount.pane.loader.text").replace("{0}", LE.translator.translate("LERegistration.myAccount." + paneName + ".title"))
                    });
                    this.loaders[paneName].render();
                },this));

                // make sure errors over panes are shown
                var errors= _.keys(this.model.get('parsed.errorText'));
                _(errors).forEach(_.bind(function(paneName){
                    var errorPane= this.$el.find('.load-error.' + paneName + '-load-error');
                    if(!errorPane.hasClass("hide")){
                        errorPane.css("display", "table");
                    }
                },this));

                this.listenTo(this, "page:closeButtonClick", this._onClosePage);
                this.delegateEvents();
            },

            loadPanes: function(){
                this.panes= this.panes ||  ['owner', 'plan', 'payment', 'invoices'];

                getData(this, 'plan');
                getData(this, 'owner');
                getData(this, 'payment');
                getData(this, 'invoices');

                //load async plans in the background for if the user will decide to proceed to the change plan page
                this.controller.billingManager.getPlans();

                function getData(that, type){
                    var deferred;

                    switch(type){
                        case 'invoices':
                        deferred= that.controller.billingManager.getInvoices();
                        break;
                        case 'payment':
                        deferred= that.controller.billingManager.getCreditCardDetails();
                        break;
                        case 'owner':
                        deferred= that.controller.billingManager.getBillingCRMDetails();
                        break;
                        case 'plan':
                        deferred= that.controller.billingManager.getCurrentAndAmmendedPlans();
                        break;
                    }

                    $.when(deferred)
                        .always(_.bind(function(flowModel, errorCode){
                            //flag pane data loading as completed
                            this.panes= _.reject(this.panes, function(paneName, index, panes) {
                              return paneName === type;
                            });
                        },that))
                        .done(_.bind(function(flowModel){
                            this.parseTemplateHelpers();
                            this.controller.refreshView();
                            if(type==='plan'){
                                //note that usage is fetched upon app start in lptagsvar so the deferred is most likely resolved instantly.
                                var deferredUsage= that.controller.billingManager.getCreditsUsageForCurrentMonth();
                                $.when(deferredUsage)
                                    .done(_.bind(function(usage){
                                        this.model.set('engagementUsage', usage);
                                        this.parseTemplateHelpers();
                                        this.controller.refreshView();
                                    },that))
                                    .fail(_.bind(function(message, errorCode, response){
                                        message= "Error fetching plan usage for my account page." + message;
                                        LERegistration.logger.info(message);
                                    },that));
                            }
                        },that))
                        .fail(_.bind(function(message, errorCode, response){
                            message= "Error fetching " + type + " for my account page." + message;
                            LERegistration.logger.info(message);

                            // update model for future re-renders
                            var errorPaneText = LE.translator.translate("LERegistration.myAccount.pane.loader.error").replace("{0}", LE.translator.translate("LERegistration.myAccount." + type + ".title"));
                            this.model.set('parsed.errorText.' + type, errorPaneText);

                            this.loaders[type].close();
                            //show error in pane
                            var errorPane = this.$el.find('.load-error.' + type + '-load-error');
                            errorPane.find('div').text(errorPaneText);
                            errorPane.css('display', 'table');

                        },that));

                }


            },

            _onClosePage: function() {
                LERegistration.logger.info("MyAccountView:_onClosePage");
                this.trigger(MyAccountView.TRIGGERING.CANCEL_BUTTON_CLICKED);
            },

            _onChangeMyPlanClicked: function() {
                this.controller.noRoutePlanSelection();
            },

            _openChat: function(){
                this.controller.openChat();
            },

            _leanMoreKnowledgePack: function(){
                LERegistration.logger.info("Learn more link was clicked","MyAccountView:_leanMoreKnowledgePack");
                LE.vent.trigger("openKP", {fragment: "billing-tier-change"});
            },

            _onViewReportsClicked: function() {
                var mstrURL = LEResourceResolver.getUrl(ApiResources.DataMarketer.MSTR);
                var reportingConfig = LE.crossModule("reporting", LE.media.actions.request, LE.mediaCodes.reporting.reqres.reportingConfig);
                mstrURL = UrlUtilities.changeKeyInUrl(mstrURL, reportingConfig.mstrParameters.LOCALE, LE.siteSettings.languageSettings.getAccountLocale(),":",",");
                mstrURL = UrlUtilities.changeKeyInUrl(mstrURL, reportingConfig.mstrParameters.TIMEZONE, LE.siteSettings.timeZoneSettings.getAccountLocale(),":",",");
                LE.navigator.open(mstrURL,'mstr_billing');
            },

            _goToBillingDashboard: function() {
                this.controller.gotoLPComUpdateDetails();
            },

            _downloadInvoice: function(event) {
                event.preventDefault();
                var invoiceNumber= $(event.currentTarget).text(); //event.currentTarget.innerText || event.currentTarget.textContent;
                InvoicesModel.downloadInvoice(invoiceNumber);

            }
        });
    });

    MyAccountView.TRIGGERING= {
        CANCEL_BUTTON_CLICKED: "cancel"
    };

    return MyAccountView;
});
